module.exports = __webpack_public_path__ + "static/During Work - 6-40fd9e32fffa0244378ab1f4082ed08c.jpg";